import storeInfo from '../store';
import { MaterialInvoices } from './types';

export const getMaterialInvoices = () => ():MaterialInvoices => {
    const { materialInvoices } = storeInfo.store.getState()
    return materialInvoices;
  }

